import React, {Component} from "react";

import Checkbox from 'rc-checkbox';

function Filter(props) {
	let attribute = props.attribute;
	let values = (typeof attribute.values == 'undefined') ? [] : attribute.values;

	function handleChange(e, attributeId, element) {
		if (typeof props.onCheckboxChange == 'function') {
			props.onCheckboxChange(e, attributeId, element);
		}
	}

	return (
		<div className="filter" key={attribute.name}>
			<h6>{attribute.name}</h6>
			{/*<Dump value={attribute}/>*/}
			{Object.keys(values).map(element => {
				return (
					<div key={element}>
						<label>
							<Checkbox
								type="checkbox"
								defaultChecked={false}
								onChange={(e) => handleChange(e, attribute.id, element)}
							/>
							&nbsp;{element} ({values[element]})
						</label>
					</div>
				);
			})}
		</div>
	);
}

export default Filter;